var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11859",
    "data-name": "Group 11859",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16874",
    "data-name": "Rectangle 16874",
    width: 15,
    height: 15,
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11858",
    "data-name": "Group 11858",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37774",
    "data-name": "Path 37774",
    d: "M15,7.524q0,3.515,0,7.031c0,.363-.081.446-.434.446H.434C.087,15,0,14.916,0,14.578Q0,7.5,0,.423C0,.091.088,0,.411,0H14.589c.323,0,.41.091.41.422q0,3.551,0,7.1M5.391,4.789h9V.61H.607V9.593H4.8V9.275q0-3.058,0-6.116A1.96,1.96,0,0,1,4.811,2.9a.274.274,0,0,1,.281-.262.281.281,0,0,1,.3.274,1.661,1.661,0,0,1,0,.211c0,.546,0,1.091,0,1.665m9,.621H10.214V14.4h4.177ZM9.6,10.219H.609V14.4H9.6Zm0-4.808h-4.2V9.59H9.6Z",
    transform: "translate(0 0)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37775",
    "data-name": "Path 37775",
    d: "M103.176,28.48a.291.291,0,1,1-.289-.282.291.291,0,0,1,.289.282",
    transform: "translate(-97.786 -26.876)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondGraph);
export default __webpack_public_path__ + "static/media/secondGraph.e64c18190ea9f91b173838c1a87a8def.svg";
export { ForwardRef as ReactComponent };